<template>
  <nav
    class="main-header navbar navbar-expand navbar-white navbar-light mb-5 mt-3"
  >
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item d-none d-sm-inline-block d-md-none">
        <a
          class="nav-link text-dark"
          data-widget="pushmenu"
          href="#"
          role="button"
          ><i class="fa fa-bars"
        /></a>
      </li>
      <li class="nav-item ml-4">
        <h3 class="nav-link text-dark mt-0 pt-2">{{ title }}</h3>
      </li>
    </ul>

    <!-- SEARCH FORM -->
    <form class="ml-3">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text" id="inputGroupPrepend"
            ><i class="fa fa-search"
          /></span>
        </div>
        <input
          type="text"
          class="form-control search-input"
          placeholder="SEARCH FOR TOPIC"
          aria-describedby="inputGroupPrepend"
          required
        />
      </div>
    </form>

    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
      <!-- Notifications Dropdown Menu -->
      <li class="nav-item dropdown">
        <a class="nav-link" data-toggle="dropdown" href="#">
          <i class="material-icons">notifications_none</i>
          <span class="badge badge-danger navbar-badge">10</span>
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
          <span class="dropdown-item dropdown-header">15 Notifications</span>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item">
            <i class="fa fa-envelope mr-2"/> 4 new messages
            <span class="float-right text-muted text-sm">3 mins</span>
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item dropdown-footer"
            >See All Notifications</a
          >
        </div>
      </li>
      <!--Messages Dropdown Menu -->
      <li class="nav-item dropdown">
        <a class="nav-link" data-toggle="dropdown" href="#">
          <img
            src="@/assets/logo_white.png"
            alt="User Avatar"
            class="img-size-32 img-circle"
          />
          {{ ($store.state.userInfo || {}).first_name }}
          <i class="material-icons">keyboard_arrow_down</i>
        </a>
        <div class="dropdown-menu dropdown-menu-right">
          <router-link :to="'/profile/'" class="dropdown-item">
            Profile
          </router-link>
          <router-link to="/logout" class="dropdown-item"> Logout </router-link>
        </div>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "Top-Nav",
  props: {
    title: String
  }
};
</script>

<style scoped>
.input-group-text {
  border-left: 1px solid #ced4da;
  border-bottom: 1px solid #ced4da;
  border-top: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.search-input {
  border-left: none;
  padding: 24px 24px 24px 0px;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
